// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lddT","comment":"styles_comment__1-RSk"};